<script>
	import * as L from 'leaflet';
	// If you're playing with this in the Svelte REPL, import the CSS using the
	// syntax in svelte:head instead. For normal development, this is better.
	import 'leaflet/dist/leaflet.css';
	import 'leaflet-compass';
	import 'leaflet-compass/dist/leaflet-compass.src.css';
	import 'leaflet.geodesic/dist/leaflet.geodesic.js';

	import { onMount } from 'svelte';

	export let name;
	let map;

	let latitude;
	let watchId;

	let lastLocation = 0;

	function createMap(container) {
		let m = L.map(container, { drawControl: true }).setView([0, 0], 13);
		// L.tileLayer(
		// 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
		// {
		// attribution: `&copy;<a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>,
		// &copy;<a href="https://carto.com/attributions" target="_blank">CARTO</a>`,
		// subdomains: 'abcd',
		// maxZoom: 14,
		// })
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
		}).addTo(m);
		m.addControl( new L.Control.Compass({autoActive: true, showDigit:true, position:'topleft'}) );
		return m;
	}

	function mapAction(container) {
		map = createMap(container);
		map.zoomControl.setPosition('topright')
	}

	function resizeMap() {
		if(map) { map.invalidateSize(); }
	}

	onMount(async () => {
		navigator.permissions.query({name:'geolocation'}).then(function(result) {
			if (result.state == 'granted') {
				report(result.state);
			} else if (result.state == 'prompt') {
				report(result.state);
				navigator.geolocation.getCurrentPosition(revealPosition,positionDenied,geoSettings);
			} else if (result.state == 'denied') {
				report(result.state);
			}
			result.onchange = function() {
				report(result.state);
			}
		});
		function report(state) {
  			console.log('Permission ' + state);
		}

		const userDisplayImage = 'images/user-compass.png';
		const defaultIcon = L.divIcon({
			className: 'my-div-icon',
			iconAnchor: [50, 50],
			html:'<div class="icon-holder"><img id="icon-img" class="user-marker-img user-marker-anim" src="'+userDisplayImage+'"/>'
		});
		let marker = L.marker([50, 50], {icon: defaultIcon}).addTo(map);
		
		let geodesic;
		watchId = navigator.geolocation.watchPosition(
			pos => {
				// const arrow = document.querySelector('.compass-circle');
				// const heading = pos.coords.heading;
				// latitude = heading;

				// arrow.style.transform = `rotate(`+lastLocation+`deg)`;
				// arrow.style.transform = `rotate(-`+heading+`deg)`;
				// console.log(heading);
				// lastLocation = heading

				map.setView([pos.coords.latitude, pos.coords.longitude], 18);

				if (geodesic)
				{
					map.removeLayer(geodesic);
				}
				geodesic = new L.Geodesic([[pos.coords.latitude, pos.coords.longitude],
												[21.422510, 39.826168]]).addTo(map);

				marker.setLatLng([pos.coords.latitude, pos.coords.longitude]); 
			}, 
			err => {
				console.warn('ERROR(' + err.code + '): ' + err.message);
			},
			{
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 100_000
			}
		);

		// navigator.geolocation.watchPosition((data) => {

		// 	// console.log(heading);
		// });
	})

</script>

<div class="map" use:mapAction />
<svelte:window on:resize={resizeMap} />
<!-- 
<main class="holder">
	<div class="compass">
		<div class="arrow"></div>
		<div class="compass-circle"></div>
		<div class="my-point"></div>
	</div>
	v:1
	{latitude}
	<button class="start-btn">Start compass</button>
</main> -->

<style>
	.map{
		height: 100%;
		width: 100%;
		top: 0px;
		left: 0px;
		z-index: 1;
		position: absolute;
	}

	.holder{
		position: absolute;
		top: 100%;
	}
	.compass {
		position: relative;
		width: 320px;
		height: 320px;
		border-radius: 50%;
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
		margin: auto;
		margin-top: 100px;
	}

	.compass > .arrow {
		position: absolute;
		width: 0;
		height: 0;
		top: -20px;
		left: 50%;
		transform: translateX(-50%);
		border-style: solid;
		border-width: 30px 20px 0 20px;
		border-color: red transparent transparent transparent;
		z-index: 1;
	}

	.compass > .compass-circle,
	.compass > .my-point {
		position: absolute;
		width: 80%;
		height: 80%;
		top: 30px;
		left: 30px;
		/* transform: translate(-50%, -50%); */
		transition: transform 0.1s ease-out;
		background: url(https://cdn.onlinewebfonts.com/svg/img_467023.png) center
			no-repeat;
		background-size: contain;
	}

	.compass > .my-point {
		opacity: 0;
		width: 20%;
		height: 20%;
		background: rgb(8, 223, 69);
		border-radius: 50%;
		transition: opacity 0.5s ease-out;
	}

	:global(.user-marker-img){
		position: absolute;
		/* top: 50%;
		right:50%; */
		transform: translate(-24%, -24%);
		width: 200px;
		height: 200px;
	}
</style>